import { render } from "./CounselorDashboard.vue?vue&type=template&id=b3e82a0e"
import script from "./CounselorDashboard.vue?vue&type=script&lang=js"
export * from "./CounselorDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script